import { SiteHeader } from "@/components/dashboard/site-header";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
	Collapsible,
	CollapsibleContent,
	CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { SubjectsDataWithSlugs } from "../index.jsx";

export default function CoursesPage() {
	const [openSections, setOpenSections] = useState([]);

	const toggleSection = (sectionId) => {
		setOpenSections((prev) =>
			prev.includes(sectionId)
				? prev.filter((id) => id !== sectionId)
				: [...prev, sectionId]
		);
	};

	console.log('SubjectsDataWithSlugs:', SubjectsDataWithSlugs);

	return (
		<main className="flex-1">
			<section className="w-full py-12 md:py-24 lg:py-32">
				<div className="container px-4 md:px-6">
					<div className="flex flex-col items-center justify-center space-y-4 text-center mb-12">
						<div className="space-y-2">
							<h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl lg:text-6xl">
								Browse Our Courses
							</h1>
							<p className="mx-auto max-w-[700px] text-muted-foreground md:text-xl">
								Explore our comprehensive collection of courses
								across multiple subjects and grade levels.
							</p>
						</div>
					</div>

					<div className="max-w-7xl mx-auto grid grid-cols-2 gap-9 space-y-4">
						{SubjectsDataWithSlugs.map((subject) => {
							const isOpen = openSections.includes(subject.slug);

							return (
								<Card
									key={subject.slug}
									className="overflow-hidden h-fit !m-0">
									<Collapsible
										open={isOpen}
										className="mt-0"
										onOpenChange={() =>
											toggleSection(subject.slug)
										}>
										<CollapsibleTrigger className="w-full">
											<CardContent className="p-6">
												<div className="flex items-center justify-between">
													<div className="flex items-center gap-4">
														<div
															className={`w-12 h-12 rounded-full ${subject.color} flex items-center justify-center`}>
															{subject.icon}
														</div>
														<h2 className="text-xl font-semibold text-left">
															{subject.name}
														</h2>
													</div>
													<ChevronDown
														className={`w-5 h-5 transition-transform duration-200 ${
															isOpen
																? "transform rotate-180"
																: ""
														}`}
													/>
												</div>
											</CardContent>
										</CollapsibleTrigger>

										<CollapsibleContent>
											<div className="px-6 pb-6">
												<div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t">
													{subject.subSubjects.map(
														(subSubject, index) => (
															<Link
																key={index}
																to={`/courses/${subject.slug}/${subSubject.slug}`}
																className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 p-2 rounded hover:bg-muted/50">
																{subSubject.name}
															</Link>
														)
													)}
												</div>
											</div>
										</CollapsibleContent>
									</Collapsible>
								</Card>
							);
						})}
					</div>
				</div>
			</section>
			<section className="w-full py-12 md:py-24 lg:py-32 bg-muted/50">
				<div className="container px-4 md:px-6">
					<div className="flex flex-col items-center justify-center space-y-4 text-center">
						<div className="space-y-2">
							<h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl">
								Frequently Asked Questions
							</h2>
							<p className="mx-auto max-w-[700px] text-muted-foreground md:text-xl">
								Find answers to common questions about our
								courses and services.
							</p>
						</div>
					</div>
					<div className="mx-auto grid max-w-5xl gap-6 py-12 md:grid-cols-2">
						{[
							{
								question: "How do I enroll in a course?",
								answer: "You can enroll in a course by visiting the Courses page, selecting the course you're interested in, and clicking the 'Enroll Now' button.",
							},
							{
								question: "What payment methods do you accept?",
								answer: "We accept various payment methods including credit/debit cards, bank transfers, and mobile money.",
							},
							{
								question:
									"Can I access the course materials offline?",
								answer: "Yes, most of our course materials can be downloaded for offline access.",
							},
							{
								question: "Do you offer refunds?",
								answer: "We offer refunds within 7 days of purchase if you're not satisfied with the course.",
							},
							{
								question:
									"How long do I have access to the course?",
								answer: "Once enrolled, you have access to the course materials for 12 months.",
							},
							{
								question: "Do you offer group discounts?",
								answer: "Yes, we offer discounts for schools and groups of 10 or more students.",
							},
						].map((faq, i) => (
							<Card key={i}>
								<CardHeader>
									<CardTitle className="text-lg">
										{faq.question}
									</CardTitle>
								</CardHeader>
								<CardContent>
									<p className="text-muted-foreground">
										{faq.answer}
									</p>
								</CardContent>
							</Card>
						))}
					</div>
				</div>
			</section>
		</main>
	);
}
